import { usesCatalogPrice } from './serviceValueFormat';

const lineAmount = (service) => (usesCatalogPrice(service) ? (service.price || 0) : 0);

/**
 * Computes the amount due shown on the customer booking review step.
 */
export function calculateBookingReviewAmountDue({
  selectedServices = [],
  selectedMembershipPlanId = null,
  selectedPlan = null,
  selectedPlanMembership = null,
  selectedMembershipId = null,
  bookingEntitlements = [],
  selectedServicePackageId = null,
  packageEntitlements = [],
  additionalCostAmount = 0,
  productsTotal = 0,
}) {
  const extra = Math.max(0, Number(additionalCostAmount) || 0);
  const products = Math.max(0, Number(productsTotal) || 0);
  const sumUncovered = (coveredIds) => selectedServices
    .filter((service) => !coveredIds.has(service.id))
    .reduce((sum, service) => sum + lineAmount(service), 0);

  // A package is all-or-nothing: it pays for its own services and the extras are charged.
  if (selectedServicePackageId) {
    const entitlement = packageEntitlements.find(
      (item) => String(item.customerServicePackageId) === String(selectedServicePackageId),
    );
    const coveredIds = new Set(entitlement?.canRedeem ? (entitlement.coveredServiceIds || []) : []);
    return sumUncovered(coveredIds) + extra + products;
  }

  if (selectedMembershipPlanId) {
    const planServiceIds = new Set(selectedPlan?.serviceIds || []);
    const extrasTotal = selectedServices
      .filter((service) => !planServiceIds.has(service.id))
      .reduce((sum, service) => sum + lineAmount(service), 0);

    if (selectedPlanMembership) {
      return extrasTotal + extra + products;
    }

    return (selectedPlan?.price ?? 0) + extrasTotal + extra + products;
  }

  if (selectedMembershipId) {
    const entitlement = bookingEntitlements.find(
      (item) => item.customerMembershipId === selectedMembershipId,
    );

    if (entitlement?.canCoverAllServices) {
      return extra + products;
    }

    return sumUncovered(new Set(entitlement?.coveredServiceIds || [])) + extra + products;
  }

  return selectedServices.reduce((sum, service) => sum + lineAmount(service), 0) + extra + products;
}

